export const formatPhoneNumberByBlocks = (phone: string, blocks: number[]): string => {
  return blocks
    .reduce<{ parts: string[]; index: number }>(
      (acc, blockSize) => {
        if (acc.index >= phone.length) {
          return acc;
        }

        const part = phone.slice(acc.index, acc.index + blockSize);
        acc.parts.push(part);
        acc.index += blockSize;

        return acc;
      },
      { parts: [], index: 0 },
    )
    .parts.join(' ');
};

export const getNationalPhoneNumber = (phone: string, callingCode: string): string => {
  const cleaned = phone.trim();
  const regex = new RegExp(`^\\+?${callingCode}\\s?`);
  return cleaned.replace(regex, '').trim();
};

export const formatPlainPhoneNumber = (phone: string) =>
  phone
    .replace(/[^\d+]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
